import { render, staticRenderFns } from "./valmistumispyynto-yek-koulutettava.vue?vue&type=template&id=39ce260e&scoped=true&"
import script from "./valmistumispyynto-yek-koulutettava.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynto-yek-koulutettava.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynto-yek-koulutettava.vue?vue&type=style&index=0&id=39ce260e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce260e",
  null
  
)

export default component.exports